import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';

const GLOBAL = require('../../Globals');

class EditClassTeacherAllocation extends Component {
	
	constructor(props){
		super(props);
		this.state = {
			id : '',
			acyear : '',
			cls : '',
			section : '',
			teacher : '',
			_message : '',
			alertClass :'',
			posts : [],
			secs : [],
			accyear : [],
			teach : []
		}
		this.onChange = this.onChange.bind(this);
		this.back = this.back.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}
	
	/** redirect to Class Teacher Allocation **/
	back(e){
		
		this.setState({_redirect :true});
	}
	
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.acyear && this.state.cls && this.state.section && this.state.teacher){
			
			PostData('teacherallocation/update',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Class Teacher Allocation Updated Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("teacherform").reset();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getclass();
		this.getsection();
		this.getteacher();
		this.getacyear();
		this.getdetails();
	}
	
	getacyear(){
		
		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear : responseJson
				});
			}
		});
	}
	
	/** get Details **/
	getdetails(){
		
		GetData('teacherallocation/getdetailsbyid/'+this.props.match.params.id).then((result) => {
			let res = result;
			if(res){
				this.setState({
					acyear : res[0]['acyear'],
					cls : res[0]['class'],
					section : res[0]['section'],
					teacher : res[0]['teacher']
				});
			}
		});
	}
	
	/** get Class **/
	getclass(){
		
		GetData('classs/getclass').then((result) => {
			let res = result;
			if(res){
				this.setState({posts:res});
			}
		});
	}
	
	/** get Section **/
	getsection(){
		
		GetData('section/getsection').then((result) => {
			let res = result;
			if(res){
				this.setState({secs:res});
			}
		});
	}
	
	/** get Teacher **/
	getteacher(){
		
		GetData('employee/getteacher').then((result) => {
			let res = result;
			if(res){
				this.setState({teach:res});
			}
		});
	}
	
  render() {
	  
	  if(this.state._redirect){
		  
		return (<Redirect to='/academic/classteacherallocate' />);
	  }
	
	  this.state.id = this.props.match.params.id;
	  
	  var items = this.state.posts;
	  var sec = this.state.secs;
	  var tea = this.state.teach;
	  var acyear = this.state.accyear;
	  
	   /** get Section By Class **/
	$("#clas").change(function(){
		var fr = $(this).val();
		var ar = $("#year").val();
		$.get(GLOBAL.BASE_URL+'section/getsecbyclass/'+ar+'/'+fr,function(o){
			//$("#acHead").removeClass('chosen_a');
			$("#secs").html('');
			$('#secs')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select Section- ')); 
			$.each(o,function(key,value){			
				   $('#secs')
					.append($("<option></option>")
					.attr("value",value.id)
					.text(value.secs)); 	
										
			});	
			//	$("#acHead").addClass('chosen_a');
			
		},'json');
	
	});
	  
    return (
		<div className="animated fadeIn">
			<div className={this.state.alertClass}>
				{this.state._message}
			</div>
			<Row>
			  <Col md="12">
				<Card>
				  <form action="" method="post" role="form" id="userform" encType="multipart/form-data" onSubmit={this.onSubmit} >
					<CardHeader>
						<strong>Edit Class Teacher Allocation</strong>
						<span className="pull-right">
							<Button outline color="primary" onClick={this.back}>Back</Button>
						</span>
					</CardHeader>
					<CardBody>
						<Row>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Academic Year <span className="text-danger">*</span></Label>
							  <select name="acyear" className="form-control" onChange={this.onChange} required id="year" value={this.state.acyear}>
								<option value="">Select</option>
								{
									acyear.map(function (item) {
										return <option value={item.id }>{item.value}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Class <span className="text-danger">*</span></Label>
							  <select name="cls" onChange={this.onChange} className="form-control" id="clas" required value={this.state.cls}> 
								<option value="">Select Class</option>
								{
									items.map(function (item) {
										return <option value={item.id }>{item.class}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Section <span className="text-danger">*</span></Label>
							  <select name="section" onChange={this.onChange} className="form-control" id="secs" required value={this.state.section} >
								<option value="">Select Section</option>
								{
									sec.map(function (item) {
										return <option value={item.id }>{item.section}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Class Teacher <span className="text-danger">*</span></Label>
							  <select name="teacher" onChange={this.onChange} className="form-control" required value={this.state.teacher} >
								<option value="">Select Teacher</option>
								{
									tea.map(function (item) {
										return <option value={item.id }>{item.empname}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						</Row>
					</CardBody>
					<CardFooter>
						<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Update</Button>
					</CardFooter>
				  </form>
				</Card>
			  </Col>
			</Row>
		</div>
	);
  }
}

export default EditClassTeacherAllocation;


// WEBPACK FOOTER //
// ./src/academic/Teacher/EditClassTeacherAllocation.js